// Utilities
import { CadastrarCompraDto, Venda } from '@/types/global'
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    isLoggedIn: false,
    isGeneratingPdf: false,
    vaquejadasLength: 0,
    mainLoading: true,
    theme: 'light',
    isDark: false,
    carrinho: {
      vendas: [] as Venda[],
      user: null,
      userData: {
        nome: '',
        cpf: '',
      },
      vaquejada: null,
      isAdmin: false,
      desconto: null,
      formaPagamento: null,
    } as CadastrarCompraDto,
    users: [] as {
      id: number;
      nome: string;
      cpf: string;
      telefone: string;
    }[],
  }),
  actions: {
    setIsLoggedIn (value: boolean) {
      this.isLoggedIn = value;
    },
    setIsGeneratingPdf (value: boolean) {
      this.isGeneratingPdf = value;
    },
    setVaquejadasLength (length: number) {
      this.vaquejadasLength = length;
    },
    setMainLoading (value: boolean) {
      this.mainLoading = value;
    },
    toggleTheme () {
      this.theme = this.theme === 'light' ? 'dark' : 'light';
      this.isDark = !this.isDark;
      localStorage.setItem('theme', this.theme);
    },
    setTheme (theme: string) {
      this.theme = theme;
      this.isDark = theme === 'dark';
      localStorage.setItem('theme', this.theme);
    },
    addVenda (venda: Venda) {
      this.carrinho.vendas.push(venda);
    },
    removeVenda (index: number) {
      this.carrinho.vendas.splice(index, 1);
    },
    clearCarrinho () {
      this.carrinho = {
        vendas: [] as Venda[],
        user: null,
        userData: {
          nome: '',
          cpf: '',
        },
        vaquejada: null,
        isAdmin: false,
        desconto: null,
        formaPagamento: null,
      } as CadastrarCompraDto;
    },
    setCarrinhoUser (user: number) {
      this.carrinho.user = user;
    },
    setCarrinhoVaquejada (vaquejada: number) {
      this.carrinho.vaquejada = vaquejada;
    },
    setCarrinhoAdmin (isAdmin: boolean) {
      this.carrinho.isAdmin = isAdmin;
    },
    setCarrinhoDesconto (desconto: number) {
      this.carrinho.desconto = desconto;
    },
    setCarrinhoFormaPagamento (formaPagamento: number) {
      this.carrinho.formaPagamento = formaPagamento;
    },
    setCarrinhoUserData (userData: { nome: string; cpf: string }) {
      this.carrinho.userData = userData;
    },
    setUsers (users: { id: number; nome: string; cpf: string; telefone: string }[]) {
      for (let i = 0; i < users.length; i++) {
        if (!this.users.find((u) => u.id === users[i].id)) {
          this.users.push(users[i]);
        }
      }
    },
    addUser (user: { id: number; nome: string; cpf: string; telefone: string }) {
      if (!this.users.find((u) => u.id === user.id)) {
        this.users.push(user);
      }
    },
    clearUsers () {
      this.users = [];
    },
  },
  getters: {
    getIsLoggedIn: (state) => state.isLoggedIn,
    getIsGeneratingPdf: (state) => state.isGeneratingPdf,
    getVaquejadasLength: (state) => state.vaquejadasLength,
    getMainLoading: (state) => state.mainLoading,
    getTheme: (state) => state.theme,
    getIsDark: (state) => state.isDark,
    getCarrinho: (state): CadastrarCompraDto => state.carrinho,
    getCarrinhoUser: (state) => state.carrinho.user,
    getCarrinhoVaquejada: (state) => state.carrinho.vaquejada,
    getCarrinhoAdmin: (state) => state.carrinho.isAdmin,
    getCarrinhoDesconto: (state) => state.carrinho.desconto,
    getCarrinhoFormaPagamento: (state) => state.carrinho.formaPagamento,
    getCarrinhoVendas: (state): Venda[] => state.carrinho.vendas,
    hasVenda: (state) => state.carrinho.vendas.length > 0,
    getSenhasNoCarrinho: (state): number[] => state.carrinho.vendas.map((v: Venda) => v.numeroSenha),
    getCarrinhoUserData: (state): { nome: string; cpf: string } => state.carrinho.userData,
    getUsers: (state) => state.users,
    hasUsers: (state) => state.users.length > 0,
    getUserById: (state) => {
      return (id: number) => state.users.find((user) => user.id === id);
    },
  }
})
